import {
  format,
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
} from 'date-fns';


export const DateInputFormat = 'MM/dd/yyyy';
export const DateHourInputFormat = 'MM/dd/yyyy hh:mm:aaa';
export const DateDisplayFormat = 'd MMM yyyy';

const formatWithOrdinal = (n: number) : string => {
  if (n > 3 && n < 21) return `${n}th`;
  switch (n % 10) {
  case 1: return `${n}st`;
  case 2: return `${n}nd`;
  case 3: return `${n}rd`;
  default: return `${n}th`;
  }
};

const getRelativeTimeText = (targetDate: Date, now: Date = new Date()): string => {
  const daysDiff = differenceInDays(targetDate, now);
  const weeksDiff = differenceInWeeks(targetDate, now);
  const monthsDiff = differenceInMonths(targetDate, now);

  if (daysDiff < 7) {
    return `in ${daysDiff} day${daysDiff === 1 ? '' : 's'}`;
  } else if (weeksDiff < 4) {
    return `in ${weeksDiff} week${weeksDiff === 1 ? '' : 's'}`;
  } else {
    return `in ${monthsDiff} month${monthsDiff === 1 ? '' : 's'}`;
  }
};

export function formatDateInfo(date: Date): string {
  const weekday = format(date, 'EEE'); // e.g. "Wed"
  const month = format(date, 'MMMM');  // e.g. "April"
  const day = formatWithOrdinal(Number(format(date, 'd'))); // e.g. "16th"
  const year = format(date, 'yyyy');   // e.g. "2025"
  const time = format(date, 'haaa').toLowerCase(); // e.g. "9am"

  const relative = getRelativeTimeText(date);

  return `${weekday}. ${month} ${day} ${year} - ${time} (${relative})`;
}

export function getPossibleDate<T = any>(value: any): T | Date {
  if (!value) {
    return value;
  }

  const date = new Date(value);

  return isNaN(+date) ? value : date;
}
